import { render, staticRenderFns } from "./PlotRecommenderRatingFilter.vue?vue&type=template&id=60101859"
import script from "./PlotRecommenderRatingFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlotRecommenderRatingFilter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PlotRecommenderRatingFilter.vue?vue&type=style&index=0&id=60101859&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports